// @flow

import React from 'react';
import type { Node } from 'react';
import type { FieldProps } from '../../../types';
import Error from '../error';
import Select from './select';

type Props = {|
  ...FieldProps,
  label: string,
  children: Node,
  custom: any,
|};

export default ({
  input,
  meta: {
    touched,
    error,
  },
  children,
  ...rest
}: Props) => (
  <div>
    <Select {...input} {...rest} error={touched && error}>
      {children}
    </Select>
    {touched && error && (<Error message={error} />)}
  </div>
);
